import { Layout } from "@/components/Layout";
import { NoindexSeo } from "@/components/Seo";
import { Link } from "react-router-dom";
import "./legal.css";

export default function ConfidentialitePage() {
  return (
    <Layout>
      <NoindexSeo
        title="Politique de confidentialité"
        path="/confidentialite"
      />
      <div className="legal">
        <div className="legal-wrap">
          <h1 className="legal-h1">Politique de confidentialité</h1>
          <p className="legal-updated">Mise à jour : 12 juillet 2026</p>

          <p className="legal-intro">
            La présente politique décrit la manière dont <b>Mon Diag
            Énergétique</b> collecte, utilise et protège vos données personnelles,
            conformément au Règlement Général sur la Protection des Données
            (RGPD, règlement UE 2016/679) et à la loi Informatique et Libertés.
          </p>

          <h2 className="legal-h2">1. Responsable du traitement</h2>
          <p className="legal-p">
            Le responsable du traitement des données est <b>Pierre Thurau</b>,
            éditeur du Service. Pour toute question relative à vos données,
            contactez-nous à l'adresse indiquée dans les{" "}
            <Link to="/mentions-legales" className="legal-link">mentions légales</Link>.
          </p>

          <h2 className="legal-h2">2. Données collectées</h2>
          <h3 className="legal-h3">2.1 Données de compte</h3>
          <ul className="legal-ul">
            <li><b>Adresse e-mail</b> : utilisée comme identifiant de connexion et pour la communication.</li>
            <li><b>Mot de passe</b> : stocké sous forme hachée (argon2id), jamais en clair.</li>
            <li><b>Date de création du compte</b> et <b>version des CGU acceptées</b> (tracabilité du consentement).</li>
            <li><b>Préférences de consentement</b> : marketing, statistiques, publicités (opt-in, désactivés par défaut).</li>
          </ul>

          <h3 className="legal-h3">2.2 Données de logement saisies</h3>
          <ul className="legal-ul">
            <li><b>Caractéristiques du logement</b> : surface, année de construction, type, système de chauffage, isolation, ventilation, etc.</li>
            <li><b>Code postal et ville</b> : pour déterminer la zone climatique et les départements.</li>
            <li><b>Résultats de calcul</b> : étiquettes DPE, consommations, déperditions, recommandations.</li>
          </ul>
          <p className="legal-p">
            <b>Aucune donnée bancaire</b> n'est stockée par le Service. Les
            paiements éventuels (offre premium) sont traités par un prestataire
            de paiement tiers certifié.
          </p>

          <h3 className="legal-h3">2.3 Données techniques</h3>
          <ul className="legal-ul">
            <li><b>Cookie de session</b> : strictement nécessaire à l'authentification (HttpOnly, Secure, SameSite=Lax).</li>
            <li><b>Logs d'audit</b> : actions sensibles (connexion, suppression, actions admin) enregistrées avec hachage de l'adresse IP.</li>
          </ul>

          <h2 className="legal-h2">3. Finalités et base légale</h2>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Finalité</th>
                <th>Base légale (RGPD)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Création et gestion du compte utilisateur</td>
                <td>Exécution du contrat (art. 6 §1 b)</td>
              </tr>
              <tr>
                <td>Calcul de l'estimation DPE et présentation des résultats</td>
                <td>Exécution du contrat (art. 6 §1 b)</td>
              </tr>
              <tr>
                <td>E-mails de conseils et de marketing</td>
                <td>Consentement (art. 6 §1 a), opt-in, révocable</td>
              </tr>
              <tr>
                <td>Statistiques d'usage anonymes</td>
                <td>Consentement (art. 6 §1 a), opt-in, révocable</td>
              </tr>
              <tr>
                <td>Sécurité et journalisation des actions</td>
                <td>Intérêt légitime (art. 6 §1 f)</td>
              </tr>
              <tr>
                <td>Respect des obligations légales (tracabilité du consentement CGU)</td>
                <td>Obligation légale (art. 6 §1 c)</td>
              </tr>
            </tbody>
          </table>

          <h2 className="legal-h2">4. Durée de conservation</h2>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Catégorie</th>
                <th>Durée</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Compte actif (données de compte + logements + DPE)</td>
                <td>Duration de vie du compte</td>
              </tr>
              <tr>
                <td>Compte supprimé (demande de suppression)</td>
                <td>Purge physique sous 30 jours après la demande</td>
              </tr>
              <tr>
                <td>Logs d'audit</td>
                <td>13 mois maximum</td>
              </tr>
              <tr>
                <td>Logs de connexion (échecs)</td>
                <td>13 mois maximum</td>
              </tr>
            </tbody>
          </table>

          <h2 className="legal-h2">5. Hébergement des données</h2>
          <p className="legal-p">
            Vos données sont hébergées en France, sur les serveurs de{" "}
            <b>Scaleway</b> (Paris). Elles ne quittent pas l'Union européenne.
            Aucun transfert vers un pays tiers n'est effectué.
          </p>

          <h2 className="legal-h2">6. Sécurité</h2>
          <ul className="legal-ul">
            <li>Mots de passe hachés avec <b>argon2id</b> (algorithme recommandé par l'ANSSI).</li>
            <li>Session via cookie <b>HttpOnly</b> (non accessible par JavaScript) et <b>Secure</b> (HTTPS uniquement).</li>
            <li>Protection contre les attaques CSRF (SameSite=Lax) et le bruteforce (limitation de débit).</li>
            <li>En-têtes de sécurité : HSTS, CSP, X-Content-Type-Options, Permissions-Policy.</li>
            <li>Journalisation des actions sensibles avec hachage de l'adresse IP.</li>
          </ul>

          <h2 className="legal-h2">7. Vos droits (RGPD)</h2>
          <p className="legal-p">
            Conformément au RGPD, vous disposez des droits suivants :
          </p>
          <ul className="legal-ul">
            <li><b>Droit d'accès</b> : consulter les données que nous détenons sur vous.</li>
            <li><b>Droit de rectification</b> : corriger des données inexactes ou incomplètes.</li>
            <li><b>Droit à la portabilité</b> : télécharger vos données dans un format structuré (JSON). Disponible depuis votre <Link to="/account" className="legal-link">page compte</Link>.</li>
            <li><b>Droit à l'effacement</b> (« droit à l'oubli ») : supprimer votre compte et vos données. Disponible depuis votre <Link to="/account" className="legal-link">page compte</Link> (purge sous 30 jours).</li>
            <li><b>Droit d'opposition</b> : refuser le traitement de vos données pour les finalités basées sur le consentement ou l'intérêt légitime.</li>
            <li><b>Droit de retirer votre consentement</b> à tout moment, sans affecter la licéité du traitement antérieur. Modifiable depuis votre <Link to="/account" className="legal-link">page compte</Link>.</li>
          </ul>
          <p className="legal-p">
            Vous pouvez exercer ces droits directement depuis votre{" "}
            <Link to="/account" className="legal-link">page compte</Link>, ou par
            e-mail à l'adresse indiquée dans les{" "}
            <Link to="/mentions-legales" className="legal-link">mentions légales</Link>.
            Vous pouvez également déposer une réclamation auprès de la{" "}
            <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="legal-link">
              CNIL
            </a>{" "}
            (www.cnil.fr).
          </p>

          <h2 className="legal-h2">8. Cookies</h2>
          <p className="legal-p">
            Le détail des cookies utilisés est disponible dans notre{" "}
            <Link to="/cookies" className="legal-link">
              politique de gestion des cookies
            </Link>.
          </p>

          <h2 className="legal-h2">9. Mineurs</h2>
          <p className="legal-p">
            Le Service n'est pas destiné aux personnes de moins de 15 ans. Nous ne
            collectons pas sciemment de données auprès de mineurs. Si vous estimez
            qu'un mineur nous a transmis des données, contactez-nous pour les
            supprimer.
          </p>

          <h2 className="legal-h2">10. Modification de la politique</h2>
          <p className="legal-p">
            La présente politique peut être modifiée à tout moment. La version
            applicable est celle en ligne à la date d'utilisation du Service. Les
            modifications substantielles seront notifiées par e-mail.
          </p>
        </div>
      </div>
    </Layout>
  );
}
